import { initialize, isAvailable, isFeatureEnabled, whenAvailable } from '@vp/ab-reader';
import { initChatWithMIAW } from './miaw/index';
import { initEmbeddedChat } from './CACTA/JSComponents/JS/main';
import { IInitChatAnywhereProps, miawEnabledLocales } from './ubik-config';

export const initChatAnywhere = (data: IInitChatAnywhereProps, scriptMode?: boolean) => {
  try {
    if (!isAvailable) initialize();
    whenAvailable(() => {
      const isFlagEnabled = isFeatureEnabled('chat_miaw_us_rollout');
      if (data.tenant && data.tenant.toLowerCase() === 'vcs') {
        initEmbeddedChat(data, scriptMode);
      } else if (data?.locale?.toLowerCase() === 'en-us' || data?.locale?.toLowerCase() === 'es-us') {
        if (isFlagEnabled) {
          initChatWithMIAW(data, scriptMode);
        } else {
          initEmbeddedChat(data, scriptMode);
        }
      } else if (miawEnabledLocales.includes(data.locale?.toLowerCase())) {
        initChatWithMIAW(data, scriptMode);
      } else {
        initEmbeddedChat(data, scriptMode);
      }
    }, 3000);
  } catch (err) {
    console.error('Chat Anywhere Error:', err);
  }
};
